import { render, staticRenderFns } from "./Dashboard2.vue?vue&type=template&id=8e1f8722"
import script from "./Dashboard2.vue?vue&type=script&lang=js"
export * from "./Dashboard2.vue?vue&type=script&lang=js"
import style0 from "./Dashboard2.vue?vue&type=style&index=0&id=8e1f8722&prod&lang=scss"
import style1 from "./Dashboard2.vue?vue&type=style&index=1&id=8e1f8722&prod&media=screen%2C%20projection&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports